


















      































    





    




    




    







    






    



    




      
































































        








        













        













        










          






















            




          




        






























        

        









          


        
      







import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ExchangeRateSettings() {
  const [rate, setRate] = useState('');
  const [originalRate, setOriginalRate] = useState(null);
  const [mode, setMode] = useState('manual'); 
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [updatingAuto, setUpdatingAuto] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    loadExchangeRate();
  }, []);

  const loadExchangeRate = async () => {
    try {
      setLoading(true);
      const response = await axios.get('https://test2.planfix-to-syrve.com/api/exchange-rate-admin');

      if (response.data.success) {
        const currentRate = response.data.rate;
        setRate(currentRate.toString());
        setOriginalRate(currentRate);
        setMode(response.data.mode || 'manual');
        setError('');
      } else {
        setError('Помилка завантаження курсу');
      }
    } catch (error) {
      console.error('Помилка:', error);
      setError('Помилка завантаження курсу');
    } finally {
      setLoading(false);
    }
  };

  const handleRateChange = (e) => {
    const value = e.target.value;
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setRate(value);
      setMessage('');
      setError('');
    }
  };

  const validateRate = () => {
    if (!rate || rate.trim() === '') {
      setError('Введіть курс');
      return false;
    }
    const numericRate = parseFloat(rate);
    if (isNaN(numericRate)) { setError('Введіть коректне число'); return false; }
    if (numericRate <= 0)  { setError('Курс має бути більше 0'); return false; }
    if (numericRate > 1000) { setError('Курс не може перевищувати 1000'); return false; }
    return true;
  };

  
  const saveRate = async () => {
    if (mode === 'auto') {
      setError('Увімкнено автоматичний режим. Вимкніть його, щоб ввести курс вручну.');
      return;
    }
    if (!validateRate()) return;

    const numericRate = parseFloat(rate);
    if (originalRate !== null && numericRate === originalRate && mode === 'manual') {
      setMessage('Курс не змінено');
      setTimeout(() => setMessage(''), 2000);
      return;
    }

    setSaving(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.put('https://test2.planfix-to-syrve.com/api/exchange-rate-admin', {
        rate: numericRate
      });

      if (response.data.success) {
        setOriginalRate(numericRate);
        setMode('manual');
        setMessage(`Курс збережено (ручний режим): 1€ = ${numericRate.toFixed(2)} ₴`);
        setTimeout(() => setMessage(''), 3000);
      } else {
        setError(response.data.error || 'Помилка оновлення курсу');
      }
    } catch (error) {
      console.error('Помилка:', error);
      setError(error.response?.data?.error || 'Помилка оновлення курсу');
    } finally {
      setSaving(false);
    }
  };

  
  const toggleAutoMode = async () => {
    if (mode === 'manual') {
      
      setUpdatingAuto(true);
      setError('');
      setMessage('');
      try {
        const response = await axios.get('https://test2.planfix-to-syrve.com/api/update-exchange-rate-auto');
        if (response.data.success) {
          setRate(response.data.rate.toString());
          setOriginalRate(response.data.rate);
          setMode('auto');
          setMessage(`Автоматичний режим увімкнено. Курс з monobank: 1€ = ${response.data.rate.toFixed(2)} ₴`);
          setTimeout(() => setMessage(''), 4000);
        } else {
          setError('Не вдалося отримати курс з monobank');
        }
      } catch (e) {
        console.error(e);
        setError('Помилка отримання курсу з monobank');
      } finally {
        setUpdatingAuto(false);
      }
    } else {
      
      try {
        const response = await axios.post('https://test2.planfix-to-syrve.com/api/exchange-rate-mode', {
          mode: 'manual'
        });
        if (response.data.success) {
          setMode('manual');
          setMessage('Автоматичний режим вимкнено. Тепер можна вводити курс вручну.');
          setTimeout(() => setMessage(''), 3000);
        }
      } catch (e) {
        console.error(e);
        setError('Помилка зміни режиму');
      }
    }
  };

  
  const refreshAutoRate = async () => {
    setUpdatingAuto(true);
    setError('');
    try {
      const response = await axios.get('https://test2.planfix-to-syrve.com/api/update-exchange-rate-auto');
      if (response.data.success) {
        setRate(response.data.rate.toString());
        setOriginalRate(response.data.rate);
        setMessage(`Курс оновлено з monobank: 1€ = ${response.data.rate.toFixed(2)} ₴`);
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (e) {
      console.error(e);
      setError('Помилка оновлення курсу');
    } finally {
      setUpdatingAuto(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') saveRate();
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        height: '100vh', fontSize: '18px', color: '#666'
      }}>
        Завантаження...
      </div>
    );
  }

  return (
    <div style={{
      padding: '20px', maxWidth: '600px', margin: '0 auto',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        backgroundColor: '#fff', borderRadius: '12px', padding: '30px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '24px', textAlign: 'center' }}>
          Налаштування курсу валют
        </h2>

        <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px', fontSize: '14px' }}>
          Встановіть курс євро до гривні для відображення цін
        </p>

        {message && (
          <div style={{
            padding: '12px', backgroundColor: '#d4edda', color: '#155724',
            marginBottom: '20px', borderRadius: '8px',
            border: '1px solid #c3e6cb', textAlign: 'center'
          }}>{message}</div>
        )}

        {error && (
          <div style={{
            padding: '12px', backgroundColor: '#f8d7da', color: '#721c24',
            marginBottom: '20px', borderRadius: '8px',
            border: '1px solid #f5c6cb', textAlign: 'center'
          }}>{error}</div>
        )}

        {}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '15px 18px', marginBottom: '25px',
          backgroundColor: mode === 'auto' ? '#e7f3ff' : '#f8f9fa',
          borderRadius: '10px',
          border: `2px solid ${mode === 'auto' ? '#2196f3' : '#dee2e6'}`,
          transition: 'all 0.3s'
        }}>
          <div>
            <div style={{ fontWeight: '600', color: '#333', fontSize: '15px' }}>
              {mode === 'auto' ? 'Автоматичний курс' : 'Ручний курс'}
            </div>
            <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
              {mode === 'auto'
                ? 'Курс оновлюється з monobank'
                : 'Курс вводиться вручну нижче'}
            </div>
          </div>

          <button
            onClick={toggleAutoMode}
            disabled={updatingAuto}
            style={{
              position: 'relative',
              width: '60px', height: '32px',
              borderRadius: '16px', border: 'none',
              backgroundColor: mode === 'auto' ? '#2196f3' : '#ccc',
              cursor: updatingAuto ? 'wait' : 'pointer',
              transition: 'background-color 0.3s',
              padding: 0
            }}
          >
            <span style={{
              position: 'absolute',
              top: '3px',
              left: mode === 'auto' ? '31px' : '3px',
              width: '26px', height: '26px',
              borderRadius: '50%', backgroundColor: '#fff',
              transition: 'left 0.3s',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
            }} />
          </button>
        </div>

        {}
        <div style={{ marginBottom: '25px' }}>
          <label style={{
            display: 'block', marginBottom: '8px', fontWeight: '600',
            color: '#555', fontSize: '14px'
          }}>
            Курс євро до гривні
          </label>

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <div style={{ flex: 2, position: 'relative' }}>
              <input
                type="text"
                value={rate}
                onChange={handleRateChange}
                onKeyPress={handleKeyPress}
                placeholder="Введіть курс (наприклад, 51.62)"
                disabled={mode === 'auto'}
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  fontSize: '18px',
                  border: error ? '2px solid #dc3545' : '1px solid #ddd',
                  borderRadius: '8px',
                  textAlign: 'center',
                  fontWeight: '500',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                  backgroundColor: mode === 'auto' ? '#f0f0f0' : '#fff',
                  color: mode === 'auto' ? '#666' : '#333',
                  cursor: mode === 'auto' ? 'not-allowed' : 'text'
                }}
                autoFocus={mode === 'manual'}
              />
            </div>

            <div style={{
              flex: 1, textAlign: 'center', fontSize: '20px',
              fontWeight: 'bold', color: '#666'
            }}>
              1 € = {rate ? parseFloat(rate).toFixed(2) : '0.00'} ₴
            </div>
          </div>

          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999', textAlign: 'center' }}>
            {mode === 'auto'
              ? 'Курс оновлюється автоматично з monobank'
              : 'Введіть курс у форматі: 51.62'}
          </div>
        </div>

        {}
        <div style={{
          display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap'
        }}>
          {mode === 'manual' ? (
            <button
              onClick={saveRate}
              disabled={saving}
              style={{
                padding: '12px 30px', backgroundColor: '#28a745', color: 'white',
                border: 'none', borderRadius: '8px', fontSize: '16px',
                fontWeight: '600', cursor: saving ? 'not-allowed' : 'pointer',
                opacity: saving ? 0.6 : 1, transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => { if (!saving) e.currentTarget.style.backgroundColor = '#218838'; }}
              onMouseLeave={(e) => { if (!saving) e.currentTarget.style.backgroundColor = '#28a745'; }}
            >
              {saving ? 'Збереження...' : 'Зберегти'}
            </button>
          ) : (
            <button
              onClick={refreshAutoRate}
              disabled={updatingAuto}
              style={{
                padding: '12px 30px', backgroundColor: '#2196f3', color: 'white',
                border: 'none', borderRadius: '8px', fontSize: '16px',
                fontWeight: '600', cursor: updatingAuto ? 'not-allowed' : 'pointer',
                opacity: updatingAuto ? 0.6 : 1, transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => { if (!updatingAuto) e.currentTarget.style.backgroundColor = '#1976d2'; }}
              onMouseLeave={(e) => { if (!updatingAuto) e.currentTarget.style.backgroundColor = '#2196f3'; }}
            >
              {updatingAuto ? 'Оновлення...' : 'Оновити зараз'}
            </button>
          )}
        </div>

        {originalRate !== null && (
          <div style={{
            marginTop: '25px', padding: '15px', backgroundColor: '#f8f9fa',
            borderRadius: '8px', textAlign: 'center', border: '1px solid #e9ecef',
            fontSize: '13px', color: '#666'
          }}>
            Поточний режим: <strong>{mode === 'auto' ? 'Автоматичний' : 'Ручний'}</strong>
            {' · '}
            Курс: <strong>{originalRate.toFixed(2)} ₴</strong>
          </div>
        )}
      </div>
    </div>
  );
}

export default ExchangeRateSettings;
